import React, { useState } from 'react';
import { toast } from 'sonner';
import { Share2, Copy, MessageCircle, Check } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { createShare } from '../utils/api';

export const ShareLinkButton = ({ kind, label = 'Send Self-Fill Link', className }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState('');
  const [copied, setCopied] = useState(false);

  const generate = async () => {
    setLoading(true);
    try {
      const share = await createShare(kind);
      setLink(`${window.location.origin}/fill/${kind}/${share.token}`);
      setOpen(true);
    } catch (err) {
      toast.error('Could not create link: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success('Link copied');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Copy failed — select and copy manually');
    }
  };

  const kindLabel = kind === 'onboarding' ? 'onboarding' : 'risk profiling';
  const waText = encodeURIComponent(`Hello! Please complete your ${kindLabel} form using this secure link: ${link}`);

  return (
    <>
      <Button onClick={generate} disabled={loading} variant="outline" className={className} data-testid={`share-${kind}-btn`}>
        <Share2 className="mr-2" size={18} />
        {loading ? 'Generating…' : label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>Client Self-Fill Link</DialogTitle>
            <DialogDescription>Share this secure link with your client to complete the form themselves.</DialogDescription>
          </DialogHeader>
          <p className="text-sm text-slate-600">
            Share this secure link with your client. They fill the form themselves and can download a PDF. Their submission appears in your dashboard automatically.
          </p>
          <div className="flex items-center gap-2 mt-2">
            <input readOnly value={link} className="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-sm bg-slate-50" data-testid="share-link-input" />
            <Button onClick={copy} variant="outline" size="sm" data-testid="copy-share-link-btn">
              {copied ? <Check size={16} /> : <Copy size={16} />}
            </Button>
          </div>
          <div className="flex gap-3 mt-3">
            <a href={`https://wa.me/?text=${waText}`} target="_blank" rel="noopener noreferrer" className="flex-1">
              <Button className="w-full bg-green-600 hover:bg-green-700 text-white"><MessageCircle className="mr-2" size={18} /> WhatsApp</Button>
            </a>
            <a href={link} target="_blank" rel="noopener noreferrer" className="flex-1">
              <Button variant="outline" className="w-full">Open Link</Button>
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ShareLinkButton;
